module.exports = __webpack_public_path__ + "static/Upbit-2b86f89a7aa4c0113a068bcb467d1535.png";